module.exports = __webpack_public_path__ + "media/images/project/angle-right-5e7e6e19a8266700eb79ea25b6256400.svg";